import "../styles/overons.scss";

export default function OverOns() {
  return (
    <section className="over-ons" id="over-ons">
      <div className="over-ons-title">
        <h2>Over ons</h2>
      </div>
      <article>
        <p>
          Web Verde doet het net even <span className="underline">anders</span>.
          Als jij anno '26 nog wilt dat je website van toegevoegde waarde is
          voor je bedrijf, moet je opvallen. Wij snappen dat als de beste. Bij
          Web Verde kijken we verder dan alleen de mooie kleurtjes en plaatjes
          op je site; <span className="underline">wij bouwen sites die jouw klanten aanzetten tot denken en
          doen.</span>
        </p>
        <p>
          Bij Web Verde doen we niet aan domweg bouwen. We gaan met jou in
          gesprek over niet alleen je eisen en wensen, maar ook je dromen. Waar
          wil jij dat jouw onderneming <span className="underline">over 5 jaar</span> staat, en hoe kan jouw
          website je daarbij helpen? Een vlot reserveringssysteem, een modern
          ontwerp of een ander tof idee? <span className="underline">Bij ons is niks te gek.</span>
        </p>
      </article>
    </section>
  );
}
